module.exports = __webpack_public_path__ + "img/rl-logo-white.0a97aef9.png";